import { useTranslation } from 'react-i18next';
import type { UseTranslationOptions } from 'react-i18next/index';

export type TranslationFn<TranslationKey> = (text: TranslationKey, options?: UseTranslationOptions<unknown>) => string;

export const useTranslateFn = <TranslationKey>() => {
  const { t } = useTranslation();
  return t as TranslationFn<TranslationKey>;
};
